import { Suspense } from "react"

import Section from "./Section"
import { sectionHeaderDefaultClasses } from "./SectionHeader"

import { useDeal } from "web/hooks/data"

export function DealWithoutFetch({ deal, ...rest }) {
  return <Section subjectType="deal" data={deal} icon="briefcase" {...rest} />
}

export function DealWithFetch({ dealId, deal, ...rest }) {
  const fetchedDeal = useDeal(dealId)
  return <DealWithoutFetch {...rest} deal={{ ...deal, ...fetchedDeal }} />
}

export default function Deal(props) {
  const { deal, dealId } = props

  const hasDeal = !!deal
  const dealIsShallow = hasDeal && deal.is_shallow

  const fetch = !hasDeal || dealIsShallow

  return (
    <Suspense
      fallback={
        <div className={sectionHeaderDefaultClasses}>
          <div className="p-2">Loading Deal Details...</div>
        </div>
      }
    >
      {!fetch && <DealWithoutFetch {...props} />}
      {fetch && <DealWithFetch {...props} dealId={dealId || deal.id} />}
    </Suspense>
  )
}
